if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            }

            // If there is no cart UI on page, keep existing behavior.
            if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              this.animateProductToCart().finally(() => {
                document.body.addEventListener(
                  'modalClosed',
                  () => {
                    setTimeout(() => {
                      CartPerformance.measure("add:paint-updated-sections", () => {
                        this.cart.renderContents(response, true);
                      });
                    });
                  },
                  { once: true }
                );
                quickAddModal.hide(true);
              });
            } else {
              this.animateProductToCart().finally(() => {
                CartPerformance.measure("add:paint-updated-sections", () => {
                  this.cart.renderContents(response, true);
                });
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }


      animateProductToCart() {
        return new Promise((resolve) => {
          const cartTarget = document.querySelector('#cart-icon-bubble');
          const sourceImage = this.getProductImageForAnimation();

          if (!cartTarget || !sourceImage) {
            this.bumpCartIcon(cartTarget, resolve);
            return;
          }

          const sourceRect = sourceImage.getBoundingClientRect();
          const targetRect = cartTarget.getBoundingClientRect();
          if (!sourceRect.width || !sourceRect.height || !targetRect.width || !targetRect.height) {
            this.bumpCartIcon(cartTarget, resolve);
            return;
          }

          const clone = sourceImage.cloneNode(true);
          clone.classList.add('xv-fly-to-cart-image');
          clone.alt = '';
          clone.setAttribute('aria-hidden', 'true');
          clone.style.width = `${sourceRect.width}px`;
          clone.style.height = `${sourceRect.height}px`;
          clone.style.left = `${sourceRect.left}px`;
          clone.style.top = `${sourceRect.top}px`;
          clone.style.position = 'fixed';
          clone.style.pointerEvents = 'none';
          clone.style.zIndex = '99999';
          document.body.appendChild(clone);

          requestAnimationFrame(() => {
            const deltaX = targetRect.left + targetRect.width / 2 - (sourceRect.left + sourceRect.width / 2);
            const deltaY = targetRect.top + targetRect.height / 2 - (sourceRect.top + sourceRect.height / 2);
            clone.style.transform = `translate(${deltaX}px, ${deltaY}px) scale(0.18)`;
            clone.style.opacity = '0.18';
          });

          const cleanup = () => {
            clone.remove();
            this.bumpCartIcon(cartTarget, resolve);
          };

          clone.addEventListener('transitionend', cleanup, { once: true });
          setTimeout(cleanup, 900);
        });
      }

      bumpCartIcon(cartTarget, resolve = () => {}) {
        if (!cartTarget) {
          resolve();
          return;
        }

        cartTarget.classList.remove('xv-cart-bump');
        requestAnimationFrame(() => {
          cartTarget.classList.add('xv-cart-bump');
        });

        setTimeout(() => {
          cartTarget.classList.remove('xv-cart-bump');
          resolve();
        }, 450);
      }

      getProductImageForAnimation() {
        const selectors = [
          '.product__media-wrapper .product__media img',
          '.product__media-wrapper img',
          '.product__media img',
          '.product-media-container img',
          '.product__modal-opener img',
          '.quick-add-modal img',
          '.card__media img',
          '.card img',
          'img'
        ];

        const roots = [
          this.closest('product-info'),
          this.closest('.product'),
          this.closest('.card-wrapper'),
          this.closest('.quick-add-modal__content'),
          this.closest('quick-add-modal'),
          this.closest('section'),
          document,
        ].filter(Boolean);

        for (const root of roots) {
          for (const selector of selectors) {
            const image = root.querySelector(selector);
            if (image && image.complete && image.getBoundingClientRect().width > 24) return image;
          }
        }

        return null;
      }


      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
